/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Faq_2_QInputs */

const en_serve_faq_2_q = /** @type {(inputs: Serve_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does it cost?`)
};

const id_serve_faq_2_q = /** @type {(inputs: Serve_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biayanya?`)
};

/**
* | output |
* | --- |
* | "What does it cost?" |
*
* @param {Serve_Faq_2_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_faq_2_q = /** @type {((inputs?: Serve_Faq_2_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Faq_2_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_faq_2_q(inputs)
	return en_serve_faq_2_q(inputs)
});